import { render, staticRenderFns } from "./checkout-promo.vue?vue&type=template&id=fb640bda"
import script from "./checkout-promo.vue?vue&type=script&lang=ts"
export * from "./checkout-promo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb640bda')) {
      api.createRecord('fb640bda', component.options)
    } else {
      api.reload('fb640bda', component.options)
    }
    module.hot.accept("./checkout-promo.vue?vue&type=template&id=fb640bda", function () {
      api.rerender('fb640bda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "checkout/checkout-promo.vue"
export default component.exports